import React , { useState } from 'react';
import {backgroundImageStyle, formContainerStyle, welcomeSectionStyle, formFieldsStyle, inputGroupStyle, labelStyle, inputStyle, submitButtonStyle, checkboxContainerStyle, checkboxStyle} from '../style/style.js';
import {REACT_APP_TERMS_AND_CONDITIONS_URL, REACT_APP_LOGO_MAX_SIZE_MB, REACT_APP_LOGO_MAX_RES_WIDTH, REACT_APP_LOGO_MAX_RES_HEIGHT, REACT_APP_LOGO_ALLOWED_EXTENSIONS} from '../config/Config.js';
import AccessModal from './AccessModal.tsx';
import { toast, ToastContainer } from 'react-toastify';
import { getFirestore, collection, query, where, getDocs } from "firebase/firestore";
import { createCustomer } from '../api/CreateCustomer.api.js';


function CreateCustomerExternalForm() {

  const MAX_ATTEMPTS = 10;


  //OPTION CONFIG FILE:
  const googleDriveLink = REACT_APP_TERMS_AND_CONDITIONS_URL;
  const logoMaxSizeMB = parseInt(REACT_APP_LOGO_MAX_SIZE_MB); 
  const logoMaxWidth = parseInt(REACT_APP_LOGO_MAX_RES_WIDTH);
  const logoMaxHeight = parseInt(REACT_APP_LOGO_MAX_RES_HEIGHT); 
  const allowedExtensionsString = REACT_APP_LOGO_ALLOWED_EXTENSIONS;

  const allowedExtensions = allowedExtensionsString.split(','); 
  const [logoFile, setLogoFile] = useState(null);

  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [formSubmitEvent, setFormSubmitEvent] = useState(null); 

  const [generatedIdentifier, setGeneratedIdentifier] = useState('');
  const [whatsapp, setWhatsapp] = useState('');
  const [instagramHandle, setInstagramHandle] = useState('');

  const db = getFirestore();
  const customerCollection = collection(db, 'customers');
  const [isGeneratingIdentifier, setIsGeneratingIdentifier] = useState(false);

  const [customerIdModal, setCustomerIdModal] = useState('');

// Handle modal opening ----------------------------------------
const openConfirmationModal = (event) => {

  const now = new Date();
  const companyNameValue = event.target.companyName.value.trim();
  
  const day = String(now.getDate()).padStart(2, '0');
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const year = now.getFullYear();
  const idDateStr = `${day}${month}${year}`;

  const cleanCompanyName = companyNameValue.toLowerCase().replace(/\s+/g, '');
  const customerId = `${cleanCompanyName}${idDateStr}`;
  setCustomerIdModal(customerId);



  event.preventDefault(); 
  const companyName = event.target.companyName.value;
  setIsGeneratingIdentifier(true); 
  generateUniqueIdentifier(companyName)
  .then(uniqueIdentifier => {
    if (uniqueIdentifier) {
      console.log(`Se generó un identifier único: "${uniqueIdentifier}"`);
      setGeneratedIdentifier(uniqueIdentifier); 
      setFormSubmitEvent(event);
      setIsGeneratingIdentifier(false);
      setIsConfirmationModalOpen(true);
    } else {
      console.error("No se pudo generar un identifier único después de varios intentos.");
      setIsGeneratingIdentifier(false);
    }
  });
};
// Handle modal opening ----------------------------------------



// Handle modal closing ----------------------------------------
  const closeConfirmationModal = () => {
    setIsConfirmationModalOpen(false);
  };
// Handle modal closing ----------------------------------------



// Handle confirmation -----------------------------------------
const handleConfirmation = async () => {

  try {
    await handleSubmit(formSubmitEvent);
    toast.success("Cliente creado con éxito.");
  } catch (error) {
    toast.error("Error al crear el cliente.");
    throw error;
  } finally {
    closeConfirmationModal();
  }
};
// Handle confirmation -----------------------------------------



// Identifier Generator -----------------------------------------
const checkIfIdentifierExists = async (identifierToCheck) => {
  try {
    const q = query(customerCollection, where('identifier', '==', identifierToCheck));
    const querySnapshot = await getDocs(q);
    return !querySnapshot.empty;
  } catch (error) {
    console.error("Error al verificar el identifier:", error);
    return true; 
  }
};


const generateUniqueIdentifier = async (companyName) => {
  let newIdentifier;
  let exists = true;
  let attempts = 0; 
  
  let prefix = companyName.trim().substring(0, 3).toLowerCase();
  if (prefix.length === 2) {
        prefix += "_";
      }

  while (exists && attempts < MAX_ATTEMPTS) {
    //const randomNumbers = Math.floor(Math.random() * 10) + 1; //Testing

    const randomNumbers = Math.floor(100 + Math.random() * 900);
    newIdentifier = `E_${prefix}${randomNumbers}`;
    console.log(`identifier in attempt ${attempts}`, newIdentifier);
    exists = await checkIfIdentifierExists(newIdentifier);
    attempts++; 
  }

  if (!exists) {
    return newIdentifier; 
  } else {
    console.error("Se alcanzó el límite de intentos para generar un identifier único.");
    return null; 
  }
};


// Identifier Generator -----------------------------------------


// Handle form submission --------------------------------------
const handleSubmit = async (e) => {
  e.preventDefault();
  const now = new Date();
  const formData = new FormData();
  const day = String(now.getDate()).padStart(2, '0');
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const year = now.getFullYear();
  const idDateStr = `${day}${month}${year}`;

  const companyNameValue = e.target.companyName.value.trim();
  const filename = `${companyNameValue.replace(/\s+/g, '_')}_${idDateStr}.png`;

  formData.append('name', companyNameValue);
  formData.append('mainUserName', e.target.personInCharge.value);
  formData.append('mainUserPhone', e.target.whatsapp.value);
  formData.append('mainUserEmail', e.target.email.value);
  formData.append('instagramUrl', `https://www.instagram.com/${instagramHandle}`);

  if (logoFile) {
    formData.append('logo', logoFile, filename);
  }
  formData.append('showWork', e.target.showWork.checked);
  formData.append('termsAndConditions', e.target.termsAndConditions.checked);
  formData.append('identifier', generatedIdentifier);
  formData.append('customerId', customerIdModal);
  formData.append("createdAt", new Date().toISOString());
  formData.append('active', 'true');

  return createCustomer(formData);
};
// Handle form submission --------------------------------------



// Handle logo file selection ----------------------------------
  const handleLogoChange = (event) => {
    const file = event.target.files[0];

    if (!file) {
      setLogoFile(null); 
      return;
    }
    
    const fileExtension = file.name.toLowerCase().substring(file.name.lastIndexOf('.'));
    if (!allowedExtensions.includes(fileExtension)) {
      toast.error("Por favor, sube solo archivos con extensión: " + allowedExtensions.join(', '), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        style: {
          background: '#FFA500',
          color: '#000000',
          borderRadius: '8px',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        }
      });
      event.target.value = null; 
      setLogoFile(null);
      return;
    }


    if (file.size > logoMaxSizeMB * 1024 * 1024) {
      toast.error(`La imagen debe tener un tamaño máximo de ${logoMaxSizeMB}MB.`, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        style: {
          background: '#FFA500',
          color: '#000000',
          borderRadius: '8px',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        }
      });
      event.target.value = null; 
      setLogoFile(null);
      return;
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      const img = new Image();
      img.onload = () => {
        if (img.width > logoMaxWidth || img.height > logoMaxHeight) {
          toast.error(`La imagen debe tener unas dimensiones máximas de ${logoMaxWidth}x${logoMaxHeight} píxeles.`, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            style: {
              background: '#FFA500',
              color: '#000000',
              borderRadius: '8px',
              boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            }
          });
          event.target.value = null; 
          setLogoFile(null);
          return;
        }
        setLogoFile(file);
      };
      img.src = e.target.result;
    };
    reader.readAsDataURL(file);
  };
// Handle logo file selection ----------------------------------



  return (
    <>
    <ToastContainer />
      <form onSubmit={openConfirmationModal}>
        <div style={backgroundImageStyle}>
          <div style={formContainerStyle}>
            <div style={welcomeSectionStyle}>


              <h1>Bienvenido/a LisualPro!</h1>
              <p>Completa los datos a continuación, para dar de alta tu empresa.</p>
              <p>Luego podrás ingresar al portal</p>

            </div>
            <div style={formFieldsStyle}>

              <div style={inputGroupStyle}>
                <label style={labelStyle} htmlFor="companyName">Nombre de la empresa*</label>
                <input style={inputStyle} type="text" id="companyName" name="companyName" required />
              </div>

{/*
              <div style={inputGroupStyle}>
                <label style={labelStyle} htmlFor="taxesId">Numero de identificación fiscal</label>
                <input style={inputStyle} type="text" id="taxesId" name="taxesId" />
              </div>
*/}              
              <div style={inputGroupStyle}>
                <label style={labelStyle} htmlFor="address">Nombre del responsable de la empresa*</label>
                <input style={inputStyle} type="text" id="personInCharge" name="personInCharge" required/>
              </div>
              
              <div style={inputGroupStyle}>
                <label style={labelStyle} htmlFor="whatsapp">Número de Wsp (ej. 5491112345678)*</label>
                <input
                  style={inputStyle}
                  type="tel"
                  id="whatsapp"
                  name="whatsapp"
                  value={whatsapp}
                  onChange={(e) => {
                    const cleaned = e.target.value.replace(/\D/g, ''); 
                    setWhatsapp(cleaned);
                  }}
                  required
                />
              </div>
              
              <div style={inputGroupStyle}>
                <label style={labelStyle} htmlFor="email">Correo del Responsable*</label>
                <input style={inputStyle} type="email" id="email" name="email" required/>
              </div>
              
              <div style={inputGroupStyle}>
                <label style={labelStyle} htmlFor="logo">Logo de tu empresa</label>
                <input style={inputStyle} type="file" id="logo" name="logo" accept=".png,.jpg,.jpeg,.pdf" onChange={handleLogoChange}/>
              </div>
              <p style={{ fontSize: '12px', color: '#555' }}>En medida de 400px x 400px, fondo transparente (preferentemente)</p>
              
              <div style={inputGroupStyle}>
                <label style={labelStyle} htmlFor="instagram">Instagram</label>
                <div style={{ display: 'flex', alignItems: 'center', ...inputStyle }}>
                  <span style={{ whiteSpace: 'nowrap', color: '#666', marginRight: '5px' }}>https://www.instagram.com/</span>
                  <input
                    style={{ border: 'none', flexGrow: 1, outline: 'none' }}
                    type="text"
                    id="instagram"
                    name="instagram"
                    value={instagramHandle}
                    onChange={(e) => setInstagramHandle(e.target.value)}
                    placeholder="Tu Instagram (sin @)"
                  />
                </div>
              </div>
              
              <div>
              </div>
              
              <div style={checkboxContainerStyle}>
                <input style={checkboxStyle} type="checkbox" id="showWork" name="showWork"/>
                <label htmlFor="showWork">Quiero que Lisual muestre mis obras</label>
              </div>
              
              <div style={checkboxContainerStyle}>
                <input style={checkboxStyle} type="checkbox" id="termsAndConditions" name="termsAndConditions" required/>
                <label htmlFor="termsAndConditions">
                    Acepto terminos y condiciones*{' '}
                    <a
                      href={googleDriveLink}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      (Leer aqui)
                    </a>
                </label>
              </div>
              
              {isGeneratingIdentifier ? (
                <div className="bg-white rounded-lg p-4 md:p-6 shadow-sm border border-gray-200">
                  <div className="flex items-center justify-center space-x-2 md:space-x-3">
                    <div className="animate-spin rounded-full h-4 w-4 md:h-5 md:w-5 border-b-2 border-blue-500"></div>
                    <p className="text-sm md:text-base text-gray-600">Generando código de acceso...</p>
                  </div>
                </div>
              ) : (

              <button style={submitButtonStyle} type="submit">
                  DARME DE ALTA
              </button>
              )}

            </div>
          </div>
        </div>
      </form>

      <AccessModal
        isOpen={isConfirmationModalOpen}
        onClose={closeConfirmationModal}
        onConfirm={handleConfirmation}
        generatedIdentifier={generatedIdentifier}
        customerId={customerIdModal}
      />

    </>
  );
}

export default CreateCustomerExternalForm;